import { formatRelative } from "date-fns";
import { comment } from "postcss";
import { set } from "lodash";

import { getIntegrationToken } from "../../isomorphic/components/helper/api";

const shopifyUrl = "https://backend.cm.newslaundry.com/api/shopify/orders";
const commentUrl = "https://backend.cm.newslaundry.com/api/comment-section";
const reportUrl = "https://backend.cm.newslaundry.com/api/report-comments";
const userUrl = "https://backend.cm.newslaundry.com/api/users";
const storyUrl = "https://backend.cm.newslaundry.com/api/story";

/*
  Create user in MySql cartoon mango database from bridgkeeper member
*/
async function createCMUser(member, activeSubscription) {
  try {
    const token = await Promise.resolve(getIntegrationToken());
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      avatar_url: member["avatar-url"],
      user_name: member["first-name"] || member["name"],
      first_name: member["first-name"],
      "last-name": member["last-name"],
      subscription_details: activeSubscription,
      email: member.email
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    const res = await fetch(userUrl, requestOptions);
    return res.json();
  } catch (err) {
    console.log(err);
  }
}

async function createShopifyOrder(payload) {
  try {
    const token = await Promise.resolve(getIntegrationToken());
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify(payload);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    const res = await fetch(shopifyUrl, requestOptions);
    return res.json();
  } catch (err) {
    console.log(err);
  }
}

async function fetchComments({ pageParam = 0, queryKey }) {
  try {
    const limit = 5;
    const token = await Promise.resolve(getIntegrationToken());
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    var requestOptions = {
      method: "GET",
      headers: myHeaders
    };

    const res = await fetch(
      `${commentUrl}/${queryKey[1].storyID}?skip=${pageParam}&limit=${limit}&sort=desc`,
      token ? requestOptions : null
    );
    return res.json();
  } catch (err) {
    console.log(err);
  }
}

async function fetchReplies({ pageParam = 1, queryKey }) {
  try {
    const token = await Promise.resolve(getIntegrationToken());
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    const res = await fetch(
      `${commentUrl}/reply/${queryKey[1].commentID}/?items=5&page=${pageParam}&sort=asc`,
      token ? requestOptions : null
    );
    return res.json();
  } catch (e) {
    console.log(e);
  }
}

async function postComment({ inputText, storyID, parentID }) {
  try {
    const token = await Promise.resolve(getIntegrationToken());
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      comments: inputText,
      parent_id: parentID,
      story_id: storyID
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };
    const res = await fetch(commentUrl, requestOptions);
    return res.json();
  } catch (e) {
    console.log(e);
  }
}

async function editComment({ inputText, id }) {
  try {
    const token = await Promise.resolve(getIntegrationToken());
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      comments: inputText,
      image: null
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    const res = await fetch(`${commentUrl}/${id}`, requestOptions);
    return res.json();
  } catch (e) {
    console.log(error);
  }
}

async function deleteComment({ id }) {
  try {
    const token = await Promise.resolve(getIntegrationToken());
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      redirect: "follow"
    };
    const res = await fetch(`${commentUrl}/deleted/${id}`, requestOptions);
    console.log(res);
  } catch (e) {
    console.log(e);
  }
}

async function updateLike({ id }) {
  try {
    const token = await Promise.resolve(getIntegrationToken());
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    var requestOptions = {
      method: "PUT",
      headers: myHeaders
    };

    await fetch(`${commentUrl}/liked/${id}`, requestOptions);
  } catch (error) {
    throw new Error(error);
  }
}

async function updateFeature(id, isFeatured) {
  try {
    const token = await Promise.resolve(getIntegrationToken());
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      is_featured: !isFeatured
    });

    var requestOptions = {
      method: "put",
      headers: myHeaders,
      redirect: "follow",
      body: raw
    };

    const res = await fetch(`${commentUrl}/featured/${id}`, requestOptions);
    console.log(res);
  } catch (error) {
    throw new Error(error);
  }
}

async function reportComment(commentID, storyID, comments, setComments) {
  const token = await Promise.resolve(getIntegrationToken());
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    comment_id: commentID,
    report_type: "1",
    is_reported: true
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  await fetch(reportUrl, requestOptions)
    .then(response => response.text())
    .then(result => {
      fetchComments(storyID, setComments);
    })
    .catch(error => console.log("error", error));
}

// in miliseconds
var units = {
  year: 24 * 60 * 60 * 1000 * 365,
  month: (24 * 60 * 60 * 1000 * 365) / 12,
  day: 24 * 60 * 60 * 1000,
  hour: 60 * 60 * 1000,
  minute: 60 * 1000,
  second: 1000
};

var rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

function getTimestamp(commentTime, currentTime) {
  var elapsed = commentTime - currentTime;

  // "Math.abs" accounts for both "past" & "future" scenarios
  for (var u in units)
    if (Math.abs(elapsed) > units[u] || u == "second")
      return rtf.format(Math.round(elapsed / units[u]), u);
}

async function deleteBookmark(storyId) {
  try {
    const token = await Promise.resolve(getIntegrationToken());
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "DELETE",
      headers: myHeaders
    };

    await fetch(`${storyUrl}/bookmark/${storyId}`, requestOptions);
  } catch (error) {
    throw new Error(error);
  }
}

async function createBookmark(id, storyDetail, isSaved) {
  try {
    const token = await Promise.resolve(getIntegrationToken());
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      story_id: id,
      story_detail: storyDetail
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw
    };

    await fetch(`${storyUrl}/bookmark`, requestOptions);
  } catch (error) {
    throw new Error(error);
  }
}

async function fetchBookmark() {
  try {
    const token = await Promise.resolve(getIntegrationToken());
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    const res = await fetch(`${storyUrl}/bookmark`, requestOptions);
    return res.json();
  } catch (e) {
    console.log(e);
  }
}

async function fetchBookmarkById(storyId) {
  try {
    const token = await Promise.resolve(getIntegrationToken());
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    const res = await fetch(`${storyUrl}/bookmark/${storyId}`, requestOptions);
    return res.json();
  } catch (e) {
    console.log(e);
  }
}

export {
  createCMUser,
  createShopifyOrder,
  fetchComments,
  fetchReplies,
  postComment,
  editComment,
  deleteComment,
  updateLike,
  updateFeature,
  getTimestamp,
  reportComment,
  createBookmark,
  deleteBookmark,
  fetchBookmark,
  fetchBookmarkById
};

/* {
    avatar_url: "https://lh6.googleusercontent.com/-TKm7sJknPPI/AAAAAAAAAAI/AAAAAAAAAg0/AMZuucmIQxnPbXg7kIRN_gJCd83gd0S8AQ/s96-c/photo.jpg",
    comments: "abc",
    created_at: "2021-11-02T02:10:42.000Z",
    id: 102,
    image_url: null,
    is_deleted: 0,
    is_edited: 0,
    liked_count: 0,
    parent_id: 94,
    story_id: "36b44692-3d26-48fb-bea8-51542500bd5d",
    updated_at: "2021-11-02T02:10:42.000Z",
    user_id: 1091018,
    user_name: null
} */
